import React, { useState, useEffect } from 'react';
import rickRollVideo from '../assets/Rick Roll (Different link + no ads).mp4';

const RickRoll = ({ trigger = false, onClose, customMessage, playWithSound = false }) => {
  const [showRickRoll, setShowRickRoll] = useState(false);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    if (trigger) {
      const hasBeenRickRolled = localStorage.getItem('hasBeenRickRolled');
      
      if (!hasBeenRickRolled) {
        setShowRickRoll(true);
        localStorage.setItem('hasBeenRickRolled', 'true');
        
        if (playWithSound) {
          // Auto-play with sound when triggered by React switch
          setTimeout(() => {
            const video = document.querySelector('.rickroll-video');
            if (video) {
              video.muted = false;
              video.play().catch(() => {
                // Fallback: show play button if autoplay fails
                setVideoReady(false);
              });
              setVideoReady(true);
            }
          }, 100);
        }
      }
    }
  }, [trigger, playWithSound]);

  const handleVideoClick = () => {
    const video = document.querySelector('.rickroll-video');
    if (video) {
      video.muted = false;
      video.play();
      setVideoReady(true);
    }
  };

  const handleClose = () => {
    setShowRickRoll(false);
    if (onClose) onClose();
  };

  if (!showRickRoll) return null;

  return (
    <div className='rickroll-overlay' onClick={handleClose}>
      <div className='rickroll-modal' onClick={(e) => e.stopPropagation()}>
        <button className='rickroll-close' onClick={handleClose}>
          ×
        </button>
        <div className='rickroll-content'>
          {!videoReady && (
            <div className="play-button-overlay" onClick={handleVideoClick}>
              <button className="play-button">▶ Click to Rick Roll!</button>
            </div>
          )}
          <video
            className="rickroll-video"
            autoPlay
            muted
            controls
            playsInline
            style={{ borderRadius: '15px', width: '100%', height: 'auto', maxWidth: '560px' }}
          >
            <source src={rickRollVideo} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
          <p>
            {customMessage || "You've been Rick Rolled Again :) Welcome to the Tech Hub Leaderboard! 😄"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RickRoll;
